import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import './FloatingContactHub.css';

const FloatingContactHub = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isAdmin = pathname.startsWith('/admin');
  const isChat = pathname === '/chat';
  if (isAdmin || isChat) return null;

  return (
    <div className="floating-contact-hub" aria-label={`${SITE_CONFIG.AGENT.NAME} contact controls`}>
      <button
        type="button"
        className="floating-concierge-button"
        onClick={() => navigate('/chat')}
        aria-label={`Open ${SITE_CONFIG.AGENT.NAME} AI Concierge`}
      >
        <span aria-hidden="true">✦</span>
        <span><strong>AI Concierge</strong><small>Ask anything</small></span>
      </button>
    </div>
  );
};

export default FloatingContactHub;
